import React from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'
import styled from 'styled-components'

import {
  fetchListings,
  deleteListing,
  updateListings,
} from '../../../modules/portal-remote/portalService'
import config from '../../../config'
import withLanguage from '../lang-select/withLanguage'
import ListingListActionPanel from './ListingListActionPanel'
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc'

class ListingListContainer extends React.Component {
  state = {
    listings: [],
  }

  componentDidMount() {
    this.requestListing()
  }

  requestListing = async () => {
    const townID = _.get(this.props, 'params.townID')
    try {
      const listings = await fetchListings({town:townID})
      this.setState({ listings })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleValueChange = async () => {
    const listings = _.map(this.state.listings, (listing, index) => {
      return {
        _id: listing._id,
        appearSeq: index + 1,
      }
    })

    try {
      await updateListings(listings)
      toast.success('Update Listing Compelete.')
    } catch (error) {
      toast.error('Update listings error: ' + error.message)
    }
  }

  onSortEnd = ({ oldIndex, newIndex, ...rest }) => {
    const newListings = arrayMove(this.state.listings, oldIndex, newIndex)

    if (!_.isEqual(this.state.listings, newListings)) {
      this.setState(
        {
          listings: newListings,
        },
        this.handleValueChange,
      )
    }
  }

  handleListingSelect = listing => {
    console.log('handle listing ')
    this.props.history.push(`listings/${listing._id}`)
  }

  handleDelete = async listing => {
    console.log('deleting', listing)
    const title = _.get(listing, `title.${this.props.language}`)
    if (window.confirm(`Are you sure delete ${title} ?`)) {
      try {
        await deleteListing(listing._id)
        await this.requestListing()
        toast.success(`${title} deleted!`)
      } catch (error) {
        toast.error(error.message)
      }
    }
  }

  render() {
    return (
      <SortableList
        pressDelay={500}
        items={this.state.listings}
        onSortEnd={this.onSortEnd}
        onListingSelect={listing => this.handleListingSelect(listing)}
        onDelete={this.handleDelete}
        language={this.props.language}
      />
    )
  }
}

const SortableList = SortableContainer(
  ({ items, onListingSelect, onDelete, language }) => {
    return (
      <div>
        {_.map(items, (listing, index) => (
          <SortableItem
            key={listing._id}
            key={`item-${index}`}
            index={index}
            listing={listing}
            onListingSelect={onListingSelect}
            onDelete={onDelete}
            language={language}
          />
        ))}
      </div>
    )
  },
)

const SortableItem = SortableElement(props => {
  return <ListingListItem {...props} />
})

const ListingListItem = ({
  listing,
  onListingSelect,
  onDelete,
  language = 'th',
}) => {
  const countPortals = _.size(listing.portals)
  const countDrafts = _.reduce(
    listing.portals,
    (prev, p) => prev + (p.status === 'DRAFT' ? 1 : 0),
    0,
  )

  return (
    <MediaWithPointer
      onClick={e => {
        console.log('click item')
        onListingSelect(listing)
      }}
    >
      <figure className="media-left">
        <p className="image is-64x64">
          <img
            src={`${config.mainImageURLPrefix}/${listing.mainImageId}`}
            alt={_.get(listing, `title.${language}`)}
          />
        </p>
      </figure>
      <div
        className="media-content"
        onClick={() => {
          console.log('hello')
        }}
      >
        <div className="content">
          <div className="columns">
            <div className="column">
              <p>
                <strong>{_.get(listing, `title.${language}`)}</strong> <br />
                <small>
                  #
                  {_.chain(listing)
                    .get(`tags.${language}`)
                    .join(' ,')
                    .value()}
                </small>
                <br />
                <br />
                {/* <small>{_.get(listing, `description.${language}`)}</small> */}
              </p>
            </div>
            <div className="column">
              <div class="control">
                <div className="tags">
                  <span class={`tag is-default`}>
                    <strong>PROFILE</strong> {' : '}
                    <span>
                      {_.chain(listing.profiles)
                        .join(',')
                        .toUpper()
                        .value() || "-"}
                    </span>
                  </span>
                  <span
                    class={`tag ${
                      listing.isUseInWeb ? 'is-primary' : 'is-default'
                    }`}
                  >
                    {listing.isUseInWeb
                      ? '[/] use in web'
                      : "[x] don't use in web"}
                  </span>
                </div>

                <div className="tags">
                  <div className="tag heading is-light">
                    portals ({countPortals})
                  </div>
                  {countDrafts > 0 && (
                    <div className="tag is-danger is-small heading">
                      draft x {countDrafts}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="media-right">
        <button
          className="delete"
          onClick={e => {
            e.stopPropagation()
            onDelete(listing)
          }}
        />
      </div>
    </MediaWithPointer>
  )
}
const MediaWithPointer = styled.article.attrs({
  className: 'media',
})`
  cursor: pointer;
`

export default withLanguage(ListingListContainer)



// WEBPACK FOOTER //
// ./src/components/templates/listing-list/ListingListContainer.js